import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "search-box position-relative me-15" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25 pb-0" }
const _hoisted_7 = { class: "row d-flex" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/ajouter-place"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
            _createTextVNode(" Ajouter place ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "mot",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher une place"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("button", {
            type: "submit",
            class: "bg-transparent text-primary transition p-0 border-0"
          }, [
            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
              _createTextVNode(" Marché "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _createVNode(_component_Field, {
              modelValue: _ctx._marche,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._marche) = $event)),
              name: "marche"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_Multiselect, _mergeProps({
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                }, field, {
                  options: _ctx.marchesOptions,
                  "preserve-search": true,
                  multiple: false,
                  searchable: true,
                  placeholder: "Sélectionner le marché",
                  label: "label",
                  "track-by": "label"
                }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "marche",
              class: "text-danger"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
              _createTextVNode(" Type "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _createVNode(_component_Field, {
              modelValue: _ctx._type,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._type) = $event)),
              name: "type"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_Multiselect, _mergeProps({
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                }, field, {
                  options: _ctx.typesOptions,
                  "preserve-search": true,
                  multiple: false,
                  searchable: true,
                  placeholder: "Sélectionner le type",
                  label: "label",
                  "track-by": "label"
                }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "type",
              class: "text-danger"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
              _createTextVNode(" Statut "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _createVNode(_component_Field, {
              name: "statut",
              modelValue: _ctx._statut,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx._statut) = $event)),
              type: "text"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_Multiselect, _mergeProps({
                  searchable: true,
                  options: [
                { value: 0, label: 'Non occupée' },
                { value: 1, label: 'Occupée' }
              ],
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                }, field, { placeholder: "Sélectionner le statut" }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("table", _hoisted_16, [
          _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Code "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Loyer base "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Marché "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, "ACTIONS ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_17, _toDisplayString(place.code), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(place.loyerBase), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(place?.marche?.libelle), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(place?.type?.type?.libelle), 1),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['badge', place?.statut === 0 ? 'bg-success' : 'bg-danger'])
                  }, _toDisplayString(place?.statut === 0 ? 'Non occupée' : 'Occupée'), 3)
                ]),
                _createElementVNode("td", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _cache[13] || (_cache[13] = _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, " Actions ", -1)),
                    _createElementVNode("ul", _hoisted_24, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ViewPlacePage', params: { id: place.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "flaticon-eyes lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Détail ")
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'EditPlacePage', params: { id: place.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode("Modifier ")
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.suppression(place.id, _ctx.places, 'places', `place n° ${place.code}`))
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Supprimer ")
                        ]), 8, _hoisted_25)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}